// Demo project settings storage functions (localStorage-based, no Firebase)
import { IProject } from '../../../types/Project';

export const getDemoProjectSettings = (projectId: string): Partial<IProject> => {
  try {
    const key = `demo_project_settings_${projectId}`;
    const stored = localStorage.getItem(key);
    return stored ? JSON.parse(stored) : {};
  } catch (error) {
    console.error('Error reading demo project settings:', error);
    return {};
  }
};

export const setDemoProjectSettings = (projectId: string, settings: Partial<IProject>): void => {
  try {
    const key = `demo_project_settings_${projectId}`;
    const existing = getDemoProjectSettings(projectId);
    const updated = { ...existing, ...settings };
    localStorage.setItem(key, JSON.stringify(updated));
  } catch (error) {
    console.error('Error saving demo project settings:', error);
  }
};
